export const RAD_STAKE_DURATION_OPTIONS = [
  { label: "周期180天", value: 180 },
  { label: "周期360天", value: 360 },
  { label: "周期720天", value: 720 },
];

export const EMPTY_PERIOD_QUOTA = {
  staked: "0",
  total: "0",
  remaining: "0",
  progress: 0,
};

export const EMPTY_RAD_TEAM_INFO = {
  depth: 0,
  directPerformance: "0 RAD",
  totalPerformance: "0 RAD",
  promotionReward: "0 BOX",
  totalCards: 0,
  cardBenefit: "0%",
  cardReward: "0 BOX",
  claimQuota: "0",
  withdrawnStaking: "0 BOX",
  withdrawnPromotion: "0 BOX",
  withdrawnCard: "0 BOX",
};
